import ToolTypologiesProvider from './ToolTypologiesContext';
import ToolTypologies from './ToolTypologies';

let Index = () => {
    return (
        <ToolTypologiesProvider>
            <ToolTypologies />
        </ToolTypologiesProvider>
    )
}

export default Index;